/**
 * @generated SignedSource<<804b7bb3eba496f554bb1113f9d55085>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendPhaseSignoffRequestInput = {
  psaMilestoneId: string;
  psaProjectId: string;
  approverPortalUserId: string;
  deadline?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendPhaseSignoffRequestMutation$variables = {
  input: SendPhaseSignoffRequestInput;
};
export type sendPhaseSignoffRequestMutation$data = {
  readonly sendPhaseSignoffRequest: {
    readonly phase: {
      readonly id: string;
      readonly portalConfig: {
        readonly signoffRequestState: string | null;
        readonly signoffRequestDeadline: string | null;
        readonly signoffRequestApproverPortalUserId: string | null;
        readonly signoffChangesRequestedNote: string | null;
      } | null;
    } | null;
  } | null;
};
export type sendPhaseSignoffRequestMutation = {
  variables: sendPhaseSignoffRequestMutation$variables;
  response: sendPhaseSignoffRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendPhaseSignoffRequestPayload",
    "kind": "LinkedField",
    "name": "sendPhaseSignoffRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhasePortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestDeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestApproverPortalUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffChangesRequestedNote",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendPhaseSignoffRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendPhaseSignoffRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eb4bb0c6fa9d790e17e2bbe983faf8e2",
    "id": null,
    "metadata": {},
    "name": "sendPhaseSignoffRequestMutation",
    "operationKind": "mutation",
    "text": "mutation sendPhaseSignoffRequestMutation(\n  $input: SendPhaseSignoffRequestInput!\n) {\n  sendPhaseSignoffRequest(input: $input) {\n    phase {\n      id\n      portalConfig {\n        signoffRequestState\n        signoffRequestDeadline\n        signoffRequestApproverPortalUserId\n        signoffChangesRequestedNote\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39d91a09c7d9df32bab4b2cd5273ad5c";

export default node;
